module.exports = __webpack_public_path__ + "school/img/baomingBg.12fd3050.jpg";